<template>
    <client-page>
        <sub-visual subTab sh="Project / Reference" index="01" total="02" tabActive="Project" bg="/images/sub/visual/sv3.jpg"> </sub-visual>

        <section class="section section--first section--last">
            <v-container>
                <div class="tit-wrap">
                    <h2 class="tit tit--lg dot-tit">Project</h2>
                </div>

                <div class="pb-10 pb-md-20">
                    <v-select v-model="filter.searchKey" :items="searchItems" outlined hide-details class="w-100 mw-sm-280px ml-auto" @input="search" />
                </div>
                <v-data-table :headers="headers" :items="items" :page.sync="page" :items-per-page="itemsPerPage" hide-default-footer mobile-breakpoint="0" @page-count="pageCount = $event" class="v-data-table--default v-data-table--no-active"></v-data-table>

                <div class="v-pagination-wrap text-center">
                    <v-pagination v-model="page" :length="pageCount" total-visible="5"></v-pagination>
                </div>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
    },
    data() {
        return {
            page: 1,
            pageCount: 0,
            itemsPerPage: 10,

            filter: {
                searchKey: null,
            },

            headers: [
                { text: "P/J 이름", value: "name", sortable: false, align: "center", width: "27%" },
                { text: "고객", value: "client", sortable: false, align: "center", width: "12%" },
                { text: "최종사용자", value: "user", sortable: false, align: "center", width: "24%" },
                { text: "연도", value: "year", sortable: false, align: "center", width: "10%" },
                { text: "서술", value: "description", sortable: false, align: "center", width: "27%" },
            ],
            items: [],
            originalItems: [
                {
                    name: "#1,2 WWT TOC, Korea",
                    client: "S-Oil",
                    user: "S-Oil",
                    year: "2022",
                    description: "TOC Analyzer",
                },
                {
                    name: "#2 ALK Revamping, Korea",
                    client: "S-Oil",
                    user: "S-Oil",
                    year: "2022",
                    description: "Analyzer Package",
                },
                {
                    name: "Moisture Analyzer, Korea",
                    client: "GS Caltex",
                    user: "GS Caltex",
                    year: "2022",
                    description: "Moisture Analyzer",
                },
                {
                    name: "Basrah Project, Iraq",
                    client: "HDEC",
                    user: "South Refineries Company (SRC)",
                    year: "2022",
                    description: "Manual Sampling System",
                },
                {
                    name: "P4 Project, Korea",
                    client: "LG Chemical",
                    user: "LG Chemical",
                    year: "2022",
                    description: "GC Analyzer with Shelter",
                },
                {
                    name: "HPC P Project, Korea",
                    client: "Hanwha Solution",
                    user: "Hanwha Solution",
                    year: "2022",
                    description: "pH Analyzer",
                },
                {
                    name: "Singapore Spring Project(Califlex), Singapore",
                    client: "DL E&C",
                    user: "Califlex",
                    year: "2022",
                    description: "Analyzer Package",
                },
                {
                    name: "D-LNC Project, Korea",
                    client: "KAS",
                    user: "Lotte Chemical",
                    year: "2022",
                    description: "Analyzer Shelter",
                },
                {
                    name: "KPC O2 Project, Korea",
                    client: "KPC",
                    user: "KPC",
                    year: "2022",
                    description: "O2 Analyzer (TDL)",
                },
                {
                    name: "Wobbe Index Project, Korea",
                    client: "HDO",
                    user: "HDO",
                    year: "2022",
                    description: "Wobbe Index Analyzer",
                },
                {
                    name: "HBr Project, Korea",
                    client: "SK Showadenko",
                    user: "SK Showadenko",
                    year: "2022",
                    description: "Analyzer Package",
                },
                {
                    name: "LG Chemical RTO in Yeosu, Korea",
                    client: "LG Chemical",
                    user: "LG Chemical",
                    year: "2021",
                    description: "FID Analyzer (HC)",
                },
                {
                    name: "NBL Project, Malaysia",
                    client: "DL E&C",
                    user: "DL E&C",
                    year: "2021",
                    description: "Analyzer Package",
                },
                {
                    name: "SOEC Pilot Project, Korea",
                    client: "SKEC",
                    user: "Bloom SK Fuel Cell",
                    year: "2021",
                    description: "Analyzer Package",
                },
                {
                    name: "SGCCUP Project, Uzbekistan",
                    client: "GS E&C",
                    user: "Enter Engineering",
                    year: "2021",
                    description: "Sampling System",
                },
                {
                    name: "Requisition for Density Analyzer, Korea",
                    client: "S-Oil",
                    user: "S-Oil",
                    year: "2021",
                    description: "Density Analyzer",
                },
                {
                    name: "SGCCUP Project, Uzbekistan",
                    client: "GS E&C",
                    user: "Enter Engineering",
                    year: "2021",
                    description: "Analyzer Package",
                },
                {
                    name: "MTBE Project, Korea",
                    client: "HEC",
                    user: "Hyundai Chemical",
                    year: "2020",
                    description: "Analyzer Package",
                },
                {
                    name: "Yeosu PVC, Korea",
                    client: "LG Chemical",
                    user: "LG Chemical",
                    year: "2020",
                    description: "O2 Analyzer",
                },
                {
                    name: "Yeosu IPA, Korea",
                    client: "LG Chemical",
                    user: "LG Chemical",
                    year: "2020",
                    description: "O2 Analyzer",
                },
                {
                    name: "GS Caltex MRO in Yeosu, Korea",
                    client: "GS Caltex",
                    user: "GS Caltex",
                    year: "2020",
                    description: "TOC Analyzer Shelter",
                },
                {
                    name: "JTB Project, Indonesia",
                    client: "ABB",
                    user: "PERTAMINA",
                    year: "2020",
                    description: "HCDP Analyzer",
                },
                {
                    name: "HPC Project, Korea",
                    client: "Daelim",
                    user: "Hyundai Chemical",
                    year: "2020",
                    description: "Analyzer PKG-3",
                },
                {
                    name: "HPC Project, Korea",
                    client: "Lotte E&C",
                    user: "Hyundai Chemical",
                    year: "2020",
                    description: "Analyzer PKG-2",
                },
                {
                    name: "HPC Project, Korea",
                    client: "HEC",
                    user: "Hyundai Chemical",
                    year: "2020",
                    description: "Analyzer PKG-1",
                },
                {
                    name: "HSVC PP5 Project, Vietnam",
                    client: "KAS",
                    user: "HSVC",
                    year: "2020",
                    description: "Analyzer PKG",
                },
                {
                    name: "HYCO Project, Korea",
                    client: "HSC",
                    user: "HENC",
                    year: "2020",
                    description: "Analyzer with Shelter",
                },
                {
                    name: "Revamping Project, Korea",
                    client: "HDO",
                    user: "HDO",
                    year: "2020",
                    description: "Analyzer Revampling",
                },
                {
                    name: "OA Revamping Project, Korea",
                    client: "HENC",
                    user: "HCC",
                    year: "2020",
                    description: "Conductivity Analyzer",
                },
                {
                    name: "WAO Project, Korea",
                    client: "HPC",
                    user: "SCT",
                    year: "2020",
                    description: "OIW Analyzer",
                },
                {
                    name: "OL1 Project, Vietnam",
                    client: "eTEC",
                    user: "HSVC",
                    year: "2020",
                    description: "Analyzer Package",
                },
                {
                    name: "Ulsan PP Project, Korea",
                    client: "UPP",
                    user: "SKEC",
                    year: "2019",
                    description: "Analyzer Package",
                },
                {
                    name: "S Project, Korea",
                    client: "SKE",
                    user: "SKEC",
                    year: "2019",
                    description: "Oil Leak Detector",
                },
                {
                    name: "Ulsan NOC Project, Korea",
                    client: "SKEC",
                    user: "NOC",
                    year: "2019",
                    description: "OIW Analyzer",
                },
                {
                    name: "ZEECO_UZGTL O2 Analyzer Cabinet, Uzbekistan",
                    client: "ZEECO",
                    user: "UZGTL",
                    year: "2019",
                    description: "O2 Analyzer Cabinet",
                },
                {
                    name: "#1 NHT, Korea",
                    client: "SKEC",
                    user: "SKIPC",
                    year: "2019",
                    description: "Local Field Analyzer",
                },
                {
                    name: "S Project(NAC Utility), Korea",
                    client: "SKE",
                    user: "SKEC",
                    year: "2019",
                    description: "Hardness Analyzer",
                },
                {
                    name: "SKIPC Moisture, Korea",
                    client: "SKEC",
                    user: "SKIPC",
                    year: "2019",
                    description: "Moisture Analyzer",
                },
                {
                    name: "Hydrogen Fuel Cell Pilot, Korea",
                    client: "SKEC",
                    user: "SKEC",
                    year: "2019",
                    description: "H2 Analyzer",
                },
                {
                    name: "The Project, Korea",
                    client: "HENC",
                    user: "HCC",
                    year: "2019",
                    description: "NIR Analyzer",
                },
                {
                    name: "Al-Zour LNG Import Project, Kuwait",
                    client: "HDEC",
                    user: "KIPIC",
                    year: "2018",
                    description: "O2 Analyzer Package",
                },
                {
                    name: "S Project, Korea",
                    client: "SKEC",
                    user: "SKE",
                    year: "2018",
                    description: "Analyzer Package",
                },
                {
                    name: "Melaka Refinery Diesel Euro 5 Project, Malaysia",
                    client: "HEC",
                    user: "Malaysian Refining Company",
                    year: "2018",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "JG Summit Stage 1 Expansion Project, Philippine",
                    client: "Posco E&C",
                    user: "JG Summit Petrochemicals Group",
                    year: "2018",
                    description: "Analyzer Package&nbsp;",
                },
                {
                    name: "JG Summit Stage 1 Expansion Project, Philippine",
                    client: "CTCI",
                    user: "JG Summit Petrochemicals Group",
                    year: "2018",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Karbala Project, Iraq",
                    client: "Emerson",
                    user: "SCOP",
                    year: "2018",
                    description: "Metering GC Analyzer Package",
                },
                {
                    name: "Al-Zour Refinery Project, Kuwait",
                    client: "HDEC",
                    user: "KIPIC",
                    year: "2017",
                    description: "Chlorine Analyzer with Local Rack",
                },
                {
                    name: "EDRF, Saudi",
                    client: "HDEC/ISG",
                    user: "Saudi Aramco",
                    year: "2017",
                    description: "Analyzer Package",
                },
                {
                    name: "Al-Zour LNG Import Project, Kuwait",
                    client: "Honeywell",
                    user: "KIPIC",
                    year: "2017",
                    description: "GC analyzer systems with shelter",
                },
                {
                    name: "Al-Zour LNG Import Project, Kuwait",
                    client: "HEC",
                    user: "KIPIC",
                    year: "2017",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "UZGTL Project, Uzbekistan",
                    client: "HEC",
                    user: "OLTIN YO'L GTL",
                    year: "2017",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Al-Zour Refinery Project, Kuwait",
                    client: "Saipem",
                    user: "KIPIC",
                    year: "2017",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Merox Reactor Installation Project, Korea",
                    client: "SKIPC",
                    user: "SKIPC",
                    year: "2017",
                    description: "Mercaptan Analyzer with shelter",
                },
                {
                    name: "HDO Revamping Project, Korea",
                    client: "HEC",
                    user: "HDO",
                    year: "2017",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "RUC Project, Korea",
                    client: "DIC",
                    user: "S-Oil",
                    year: "2016",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "CFP Project, Kuwait",
                    client: "SKEC",
                    user: "KNPC",
                    year: "2016",
                    description: "AAQMS Package with shelter",
                },
                {
                    name: "RUC Project, Korea",
                    client: "Daewoo E&C",
                    user: "S-Oil",
                    year: "2016",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Karbala Project, Iraq",
                    client: "HDEC",
                    user: "SCOP",
                    year: "2015",
                    description: "AAQMS Package with shelter",
                },
                {
                    name: "Karbala Project, Iraq",
                    client: "HDEC",
                    user: "SCOP",
                    year: "2015",
                    description: "Analyzer Package with shelter (included CEMS)",
                },
                {
                    name: "Karbala Project, Iraq",
                    client: "GS E&C",
                    user: "SCOP",
                    year: "2015",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Karbala Project, Iraq",
                    client: "SKEC",
                    user: "SCOP",
                    year: "2015",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "YNCC C5 Project, Korea",
                    client: "HENC",
                    user: "YNCC",
                    year: "2015",
                    description: "O2 Analyzer system",
                },
                {
                    name: "RPLC DA-1,2 Project, Venezuela",
                    client: "HDEC",
                    user: "PDVSA",
                    year: "2015",
                    description: "OIW, ZrO2 Analyzer",
                },
                {
                    name: "UZONE (Kandym), Uzbekistan&nbsp;",
                    client: "HEC",
                    user: "Lukoil Uzbekistan Operating Company",
                    year: "2015",
                    description: "Analyzer Package and AAQMS with shelter",
                },
                {
                    name: "Ethane Cracker and PE/PP Plant, Turkmenistan",
                    client: "HDEC",
                    user: "TURKMENGAS",
                    year: "2015",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Jazan Refinery & Terminal Project, Saudi Arabia",
                    client: "SKEC",
                    user: "Aramco Overseas Company B.V",
                    year: "2015",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Asahimas Phase-VI Project (Package-1), Indonesia",
                    client: "HEC",
                    user: "P.T. Asahimas Chemical",
                    year: "2014",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Aromatics II Debottlenecking Project, Thailand",
                    client: "SKEC",
                    user: "PTT Global Chemical Public Company",
                    year: "2014",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Satah Al Razboot Field Development Project, UAE",
                    client: "HDEC",
                    user: "ADMA OPCO",
                    year: "2014",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "ERC Refinery Project, Egypt",
                    client: "GS E&C",
                    user: "Egyptian Refining Company S.A.E",
                    year: "2014",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "LAB(Linear Alkyl Benzene)Plant Project, Thailand",
                    client: "HDEC",
                    user: "Thai Oil Public Co., Ltd.",
                    year: "2014",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "IRPC UHV Project, Thailand",
                    client: "SKEC",
                    user: "IRPC Public Company Limited",
                    year: "2014",
                    description: "CEMS Systems with shelter",
                },
                {
                    name: "GTPOGT Project, Turkmenistan",
                    client: "HEC",
                    user: "Petronas Carigali(Turkmenistan) SDN BHD.",
                    year: "2014",
                    description: "Analyzer Package&nbsp;",
                },
                {
                    name: "SADARA Project, Saudi Arabia",
                    client: "eTEC",
                    user: "SABIC",
                    year: "2013",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "IRPC UHV Project, Thailand",
                    client: "SKEC",
                    user: "IRPC Public Company Limited",
                    year: "2013",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Turkmenbashi Oil Refinery Reconstruction Project, Turkmenistan",
                    client: "HDEC",
                    user: "Turkmenbashi Oil Processing Complex",
                    year: "2013",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "IRPC UHV Project, Thailand",
                    client: "GS E&C",
                    user: "IRPC Public Company Limited",
                    year: "2013",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "RPLC Deep Conversion Project, Venezuela",
                    client: "HDEC",
                    user: "PDVSA",
                    year: "2013",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "IDC Expansion Project, Saudi Arabia",
                    client: "eTEC",
                    user: "Saudi International Petrochemical",
                    year: "2013",
                    description: "Analyzer Package&nbsp;",
                },
                {
                    name: "Dolphin Project, Korea",
                    client: "eTEC",
                    user: "UMICORE",
                    year: "2013",
                    description: "H2 & O2 Analyzer",
                },
                {
                    name: "V Project, Korea",
                    client: "HDEC",
                    user: "SKI",
                    year: "2013",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "New PX Project, Korea",
                    client: "SKEC",
                    user: "SKI",
                    year: "2013",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Nexlene Project, Korea",
                    client: "SKEC",
                    user: "SKI",
                    year: "2012",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Cilacap RFCC Project, Indonesia",
                    client: "GS E&C",
                    user: "PT. Pertamina (PERSERO)",
                    year: "2012",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "MGP Project, Oman",
                    client: "HDEC",
                    user: "OOCEP",
                    year: "2012",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "HBO Project, Korea",
                    client: "SaeHan Hitech",
                    user: "SKE",
                    year: "2012",
                    description: "Pour Point/ Hydrocarbon/ H2 Analyzer",
                },
                {
                    name: "T Project, Korea",
                    client: "eTEC",
                    user: "Nisso Namhae Agro",
                    year: "2012",
                    description: "Moisture Analyzer",
                },
                {
                    name: "CLX Project, Korea",
                    client: "SKE",
                    user: "SKE",
                    year: "2012",
                    description: "Distillation Analyzer system",
                },
                {
                    name: "KOTC Um Aish New Filling Plant Projct, Kuwait",
                    client: "HENC",
                    user: "KOC&nbsp;",
                    year: "2012",
                    description: "Dew Point Analyzer system",
                },
                {
                    name: "3PZ Project, Korea",
                    client: "eTEC",
                    user: "HPC",
                    year: "2012",
                    description: "Analyzer Package",
                },
                {
                    name: "LNG Plant R&D Project, Korea",
                    client: "GS E&C",
                    user: "LNG PLANT R&D CENTER",
                    year: "2012",
                    description: "GC Analyzer",
                },
                {
                    name: "Yanbu Export Refinery Project (PKG 2), Saudi Arabia",
                    client: "SKEC",
                    user: "Saudi Aramco",
                    year: "2012",
                    description: "Analyzer Package System",
                },
                {
                    name: "VGOFCC Project, Korea",
                    client: "GS Caltex",
                    user: "GS Caltex",
                    year: "2012",
                    description: "Oil in Water Analyzer system",
                },
                {
                    name: "LBO Project, UAE",
                    client: "HDEC",
                    user: "Takreer",
                    year: "2011",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "SKGC Project, Korea",
                    client: "SKI",
                    user: "SKGC",
                    year: "2011",
                    description: "HC Analyzer Package",
                },
                {
                    name: "SaeHan_SK H Project, Korea",
                    client: "SaeHan Hitech",
                    user: "SKI",
                    year: "2011",
                    description: "Analyzer Package",
                },
                {
                    name: "Voltaix Korea New Germane Plant Project",
                    client: "Voltaix Korea",
                    user: "Voltaix Korea",
                    year: "2011",
                    description: "Analyzer Package",
                },
                {
                    name: "Clean Fuel Project, Thailand",
                    client: "SKEC",
                    user: "PTT-AR",
                    year: "2011",
                    description: "Sample Recovery System for Analyzer Package",
                },
                {
                    name: "KOC Pipeline Project, Kuwait",
                    client: "HDEC",
                    user: "KOC&nbsp;",
                    year: "2011",
                    description: "Analyzer w/Shelter",
                },
                {
                    name: "S-Oil Off-site Automation Project, Korea",
                    client: "ISU E&C",
                    user: "S-Oil",
                    year: "2011",
                    description: "B-C Blending OIW and Viscosity Analyzer",
                },
                {
                    name: "Esmeraldas Refinery Project, Ecuador",
                    client: "SKEC",
                    user: "EP Petroecuador",
                    year: "2011",
                    description: "COD Analyzer System",
                },
                {
                    name: "BS-132 Project, Kuwait",
                    client: "SKEC",
                    user: "KOC&nbsp;",
                    year: "2011",
                    description: "Process Analyzer System",
                },
                {
                    name: "Esmeraldas Refinery Project, Ecuador",
                    client: "SKEC",
                    user: "EP Petroecuador",
                    year: "2010",
                    description: "HC Analyzer System",
                },
                {
                    name: "S-Oil Off-site Automation Project, Korea",
                    client: "ISU E&C",
                    user: "S-Oil",
                    year: "2010",
                    description: "B-C Blending Analyzer System with shelter",
                },
                {
                    name: "Clean Fuel Project, Thailand",
                    client: "SKEC",
                    user: "PTT-AR",
                    year: "2010",
                    description: "Analyzer Package System with Shelter",
                },
                {
                    name: "Clean Fuel Project, Thailand",
                    client: "SKEC",
                    user: "PTT-AR",
                    year: "2010",
                    description: "CEMS Analyzer Systems with shelter",
                },
                {
                    name: "SK Incheon Micro Dist' Analyzer, Korea",
                    client: "SKE",
                    user: "SKE",
                    year: "2010",
                    description: "Distillation Analyzer system with shelter",
                },
                {
                    name: "SKIKDA Refinery Project, Algeria",
                    client: "Green Entech",
                    user: "SONATRACH",
                    year: "2010",
                    description: "Oil in Water Analyzer system",
                },
                {
                    name: "HDO BTX Project, Korea",
                    client: "HDO",
                    user: "HDO",
                    year: "2010",
                    description: "GC analyzer systems with shelter",
                },
                {
                    name: "HDO #2 HOU Project, Korea",
                    client: "HDEC",
                    user: "HDO",
                    year: "2010",
                    description: "TMS Analyzer with shelter",
                },
                {
                    name: "HDO #2 HOU Project, Korea",
                    client: "HDEC",
                    user: "HDO",
                    year: "2010",
                    description: "Analyzer Package System with Shelter",
                },
                {
                    name: "S-Oil Expansion Project, Korea",
                    client: "SECL",
                    user: "S-Oil",
                    year: "2010",
                    description: "Analyzer Package System with Shelter",
                },
                {
                    name: "Bongkot Project, Thailand",
                    client: "HHI",
                    user: "PTTEP",
                    year: "2010",
                    description: "HC Dew&nbsp;Point Analyzer system",
                },
                {
                    name: "SDA Project, Korea",
                    client: "SKEC",
                    user: "SKE",
                    year: "2009",
                    description: "Hydrocarbon Analyzer system",
                },
                {
                    name: "No.3 HOU Project, Korea",
                    client: "GS E&C",
                    user: "GS Caltex",
                    year: "2009",
                    description: "Oil in Water Analyzer system",
                },
                {
                    name: "HDO MRO Project, Korea",
                    client: "HDO",
                    user: "HDO",
                    year: "2009",
                    description: "Flash Point Analyzer & Distillation Analyzer system",
                },
                {
                    name: "RRC Upgrading Project, Thailand",
                    client: "SKEC",
                    user: "Rayong Refinery Public Co., Ltd.",
                    year: "2009",
                    description: "Sample Draining System",
                },
                {
                    name: "KCC P2 Project, Korea",
                    client: "HDEC",
                    user: "KCC",
                    year: "2009",
                    description: "Analyzer Package System with Shelter",
                },
                {
                    name: "KOC GC#24 Project, Kuwait",
                    client: "SKEC",
                    user: "KOC&nbsp;",
                    year: "2009",
                    description: "DO, Density analyzer system",
                },
                {
                    name: "No.3 HOU Project, Korea",
                    client: "GS E&C",
                    user: "GS Caltex",
                    year: "2009",
                    description: "Flash Point Analyzer & Distillation Analyzer system",
                },
                {
                    name: "DHT Project, Saudi",
                    client: "SECL",
                    user: "Saudi Aramco",
                    year: "2009",
                    description: "Field analyzer system",
                },
                {
                    name: "S-Oil Alkylation Project, Korea",
                    client: "HDEC",
                    user: "S-Oil",
                    year: "2009",
                    description: "Field Analyzer Package System with Shelter",
                },
                {
                    name: "ROPP Project, Indonesia",
                    client: "Toyo Korea",
                    user: "PT. Pertamina (PERSERO)",
                    year: "2008",
                    description: "Analyzer Package System with Shelter",
                },
                {
                    name: "S-Oil Alkylation Project, Korea",
                    client: "HDEC",
                    user: "S-Oil",
                    year: "2008",
                    description: "GC Analyzer Package System with Shelter",
                },
                {
                    name: "RRC Upgrading Project, Thailand",
                    client: "SKEC",
                    user: "Rayong Refinery Public Co., Ltd.",
                    year: "2008",
                    description: "Analyzer Package System with Shelter",
                },
                {
                    name: "RRC Upgrading Project, Thailand",
                    client: "SKEC",
                    user: "Rayong Refinery Public Co., Ltd.",
                    year: "2007",
                    description: "CEMS Analyzer package system with shelter",
                },
                {
                    name: "KPPC Aromatics Complex Project, Kuwait",
                    client: "Tecnimont S.p.A",
                    user: "Kuwait Paraxylene Production Company",
                    year: "2007",
                    description: "O2 Analyzer",
                },
                {
                    name: "KPPC Aromatics Complex Project, Kuwait",
                    client: "SKEC",
                    user: "Kuwait Paraxylene Production Company",
                    year: "2007",
                    description: "O2/ Density/ Mositure/ HC/ NIR and RVP Analyzer",
                },
                {
                    name: "SKICO New FCC Project, Korea",
                    client: "SKEC",
                    user: "SKE",
                    year: "2007",
                    description: "GC analyzer systems with shelter",
                },
                {
                    name: "SKICO New FCC Project, Korea",
                    client: "SKEC",
                    user: "SKE",
                    year: "2007",
                    description: "HC, CL, COD Analyzer system",
                },
                {
                    name: "LBO Project, Indonesia",
                    client: "SKEC",
                    user: "PT. Patra-SK",
                    year: "2007",
                    description: "Process analyzer package system with Shelter",
                },
                {
                    name: "Gunjang GO-GEN Project, Korea",
                    client: "HENC",
                    user: "Gunjang Energy Company",
                    year: "2007",
                    description: "CEMS Analyzer package system with shelter",
                },
                {
                    name: "RW Project, Korea",
                    client: "eTEC",
                    user: "OCI",
                    year: "2007",
                    description: "GC, H2,O2, CO, CO2&nbsp;Analyzers Package System",
                },
                {
                    name: "ROC Furnace Q Project, Thailand",
                    client: "Woo Ree Engineering",
                    user: "ROC Oil Company Limited",
                    year: "2007",
                    description: "CO/O2 Analyzer, Sampling System with Local Panel",
                },
                {
                    name: "PTT Standby Stabilizer Unit, Thailand",
                    client: "DaeWoo E&C",
                    user: "PTT Public Company",
                    year: "2006",
                    description: "RVP Analyzer, Sampling System with Local Panel",
                },
                {
                    name: "#6 MDU Project, Korea",
                    client: "SKEC",
                    user: "SKE",
                    year: "2006",
                    description: "H2 Analyzer system",
                },
                {
                    name: "#6 MDU Project, Korea",
                    client: "SKEC",
                    user: "SKE",
                    year: "2006",
                    description: "Chlorine Analyzer with Local Panel",
                },
                {
                    name: "#6 MDU Project, Korea",
                    client: "SKEC",
                    user: "SKE",
                    year: "2006",
                    description: "HC Analyzer, Sampling System with Local Panel",
                },
                {
                    name: "#6 MDU Project, Korea",
                    client: "SKEC",
                    user: "SKE",
                    year: "2006",
                    description: "Viscosity, Pour, HC Analyzer System",
                },
                {
                    name: "KOC FMP Project, Kuwait",
                    client: "SKEC",
                    user: "KOC&nbsp;",
                    year: "2006",
                    description: "HC Analyzer, Sampling System with Local Panel",
                },
                {
                    name: "Reformer and Aromatics complex II Project, Thailand",
                    client: "GS E&C",
                    user: "Aromatics Thailand Public Co.,Ltd.",
                    year: "2006",
                    description: "pH, Conductivity, DO, MLSS, Auto Sampler with Local Panel",
                },
                {
                    name: "Reformer and Aromatics complex II Project, Thailand",
                    client: "GS E&C",
                    user: "Aromatics Thailand Public Co.,Ltd.",
                    year: "2006",
                    description: "H2, O2 Analyzer, Sampling System with Local Panel",
                },
                {
                    name: "Reformer and Aromatics complex II Project, Thailand",
                    client: "SKEC",
                    user: "Aromatics Thailand Public Co.,Ltd.",
                    year: "2006",
                    description: "Analyzer Package System with Local Panel",
                },
                {
                    name: "PTT Solvay Onsan K2-Project, Korea",
                    client: "eTEC",
                    user: "PTT Solvay",
                    year: "2006",
                    description: "RVP Analyzer, Sampling System with Local Panel",
                },
                {
                    name: "IZMR.DHP Project, Turkey",
                    client: "KAS System Co., Ltd.",
                    user: "Tupras Corp.",
                    year: "2006",
                    description: "H2, Portable O2 Analyzer system",
                },
                {
                    name: "Aromatic Project, China",
                    client: "KAS System Co., Ltd.",
                    user: "GS E&C",
                    year: "2006",
                    description: "Oil in Water, Portable O2, H2 Analyzer system",
                },
                {
                    name: "KES2 Project, Korea",
                    client: "eTEC",
                    user: "Dongwoo Fine-Chem Co.,Ltd.",
                    year: "2006",
                    description: "O2 Analyzer system",
                },
                {
                    name: "#3CDU Project, Korea",
                    client: "SKE",
                    user: "SKE",
                    year: "2005",
                    description: "Cloud, Pour, Freezing point analyzer system",
                },
                {
                    name: "DCC KN Project, Korea",
                    client: "OCI",
                    user: "OCI",
                    year: "2005",
                    description: "H2 Analyzer system",
                },
                {
                    name: "DCC KT Project, Korea",
                    client: "OCI",
                    user: "OCI",
                    year: "2005",
                    description: "H2, CO, CO2 analyzer system",
                },
                {
                    name: "KES1-Project, Korea",
                    client: "eTEC",
                    user: "Daewoo Precision Industries Co.,Ltd.",
                    year: "2005",
                    description: "O2 Analyzer system",
                },
                {
                    name: "FCC Feed HDT&nbsp;Project, Romania",
                    client: "SKEC",
                    user: "SNP Petrom S.A",
                    year: "2004",
                    description: "Analyzer Package System with Local Panel",
                },
                {
                    name: "Songwon Industrial Incinerator Project, Korea",
                    client: "Dasan RND Co., Ltd.",
                    user: "Songwon Ind.",
                    year: "2004",
                    description: "CEMS Systems",
                },
                {
                    name: "ATC De-bottleneckingⅡProject, Thailand",
                    client: "SKEC",
                    user: "Aromatics Thailand Public Co.,Ltd.",
                    year: "2004",
                    description: "Analyzer Package System with Shelter",
                },
                {
                    name: "N Project, Korea",
                    client: "HENC",
                    user: "HENC",
                    year: "2004",
                    description: "CEMS Systems with shelter",
                },
            ],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.search();
        },
        search() {
            this.page = 1;
            if (!this.filter.searchKey) {
                this.items = this.originalItems;
            } else {
                this.items = this.originalItems.filter((el) => this.filter.searchKey === el.year);
            }
        },
    },
    computed: {
        searchItems() {
            let result = [{ text: ":: ALL ::", value: null }];

            let year = [];
            for (let i = 0; i < this.originalItems.length; i++) {
                if (year.indexOf(this.originalItems[i].year) === -1) {
                    year.push(this.originalItems[i].year);
                    result.push({ text: this.originalItems[i].year, value: this.originalItems[i].year });
                }
            }

            return result;
        },
    },
};
</script>

<style lang="scss" scoped></style>
